export default __webpack_public_path__ + "static/media/6-seeblue.3a35f54b.png";